import { render, staticRenderFns } from "./liveForm.vue?vue&type=template&id=05bd3efc&scoped=true&"
import script from "./liveForm.vue?vue&type=script&lang=js&"
export * from "./liveForm.vue?vue&type=script&lang=js&"
import style0 from "./liveForm.vue?vue&type=style&index=0&id=05bd3efc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bd3efc",
  null
  
)

export default component.exports